import React from 'react';
import GoogleReviews from './GoogleReviews';

const Reviews = () => {
  return <GoogleReviews />;
}

export default Reviews;